import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgParamAltitude = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M15.75 6.75L12 3L8.25 6.75M12 3V21",
			stroke: "var(--stroke-0, #DFCBF5)",
			strokeOpacity: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgParamAltitude;
